import React from 'react'

export function Divider() {
  return <div className="border-t border-moss-300" />
}
